import { Field } from '@ontruck/orc';
import { useCallback } from 'react';

import { usePOIVenueDetail } from 'modules/point-of-interest';

const getParsedValue = (value) => {
  if (value.startsWith('ontruck_venue')) {
    return `ontruck:venue:${value}`;
  }

  return value;
};

const POIDebugger = () => {
  const { openModal } = usePOIVenueDetail();

  const handleEnter = useCallback(
    (e) => {
      if (e.charCode !== 13) {
        return;
      }

      const value = getParsedValue(e.target.value);

      openModal(value);
    },
    [openModal]
  );

  return (
    <div style={{ padding: 45, width: 500 }}>
      <Field id="id" name="id" label={'Venue ID'} fullWidth onKeyPress={handleEnter} />
    </div>
  );
};

export default POIDebugger;
